// src/context/LeadContext.js
import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";

const LeadContext = createContext(null);

export function useLead() {
  const ctx = useContext(LeadContext);
  if (!ctx) throw new Error("useLead must be used within <LeadProvider>");
  return ctx;
}

export function LeadProvider({ children }) {
  const [lead, setLead] = useState(() => {
    try {
      const saved = localStorage.getItem("lead_prefill");
      return saved
        ? JSON.parse(saved)
        : {
            zip: "",
            name: "",
            email: "",
            phone: "",
            dob: "",
            sex: "",
            tobacco: "",
            message: "",
          };
    } catch {
      return {
        zip: "",
        name: "",
        email: "",
        phone: "",
        dob: "",
        sex: "",
        tobacco: "",
        message: "",
      };
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem("lead_prefill", JSON.stringify(lead));
    } catch {}
  }, [lead]);

  const value = useMemo(() => ({ lead, setLead }), [lead]);
  return <LeadContext.Provider value={value}>{children}</LeadContext.Provider>;
}
